import {
    editorUpsellLabelWithSuggestions,
    settingsDialogTrySuggestionsString,
    editorUpsellLabelWithOneSuggestion,
    settingsDialogActiveDaysToGo,
    settingsDialogActiveSuggestionsToGo,
    editorUpsellLabelWithZeroSuggestions,
    editorUpsellLabelWithSuggestionsExpired,
    skittleDialogSettingsTryItNowButton,
    settingsDialogActiveOneDayToGo,
    settingsDialogActiveOneSuggestionToGo,
} from './EditorUpsellStrings.locstring.json';
import loc, { format } from 'owa-localize';
import { ProofingViewState } from '../store/schema/ProofingViewState';
import { PremiumPreviewStatus, PremiumPreviewType } from '../store/schema/PremiumPreviewData';
import { skittleGoPremiumButton } from '../components/SkittleCallout.locstring.json';

/**
 * returns the upsell strings to display in the bottom of settings
 * based on the premium preview experiments.
 */
export function getUpsellSettingsStrings(
    proofingViewState: ProofingViewState
): { buttonString: string; upsellString: string } {
    let upsellString: string;
    let buttonString: string;

    const { premiumPreviewData } = proofingViewState;
    const { premiumPreviewStatus } = premiumPreviewData;
    // Same strings for basic skittle and new premium preview status
    if (premiumPreviewStatus === PremiumPreviewStatus.New) {
        if (proofingViewState.premimumFlagsFound === 0) {
            upsellString = loc(editorUpsellLabelWithZeroSuggestions);
        } else if (proofingViewState.premimumFlagsFound === 1) {
            upsellString = loc(editorUpsellLabelWithOneSuggestion);
        } else if (proofingViewState.premimumFlagsFound > 1) {
            upsellString = format(
                loc(editorUpsellLabelWithSuggestions),
                proofingViewState.premimumFlagsFound.toString()
            );
        }

        // for activated status, the string should be x days left / x suggestions left
    } else if (premiumPreviewStatus === PremiumPreviewStatus.Activated) {
        if (premiumPreviewData.premiumPreviewType === PremiumPreviewType.TimeBased) {
            let stringDaysToShow;
            if (premiumPreviewData.numberOfDaysLeftToUsePremiunSuggestions === 1) {
                stringDaysToShow = settingsDialogActiveOneDayToGo;
            } else {
                stringDaysToShow = settingsDialogActiveDaysToGo;
            }
            upsellString = format(
                loc(stringDaysToShow),
                premiumPreviewData.numberOfDaysLeftToUsePremiunSuggestions
            );
        } else if (premiumPreviewData.premiumPreviewType === PremiumPreviewType.CountBased) {
            let stringSuggestionsToShow;
            if (premiumPreviewData.premiumSuggestionsCount === 1) {
                stringSuggestionsToShow = settingsDialogActiveOneSuggestionToGo;
            } else {
                stringSuggestionsToShow = settingsDialogActiveSuggestionsToGo;
            }

            upsellString = format(
                loc(stringSuggestionsToShow),
                premiumPreviewData.premiumSuggestionsCount
            );
        }
    } else if (
        premiumPreviewStatus === PremiumPreviewStatus.Expired ||
        premiumPreviewData.premiumPreviewType === PremiumPreviewType.BasicSkittle
    ) {
        if (proofingViewState.premimumFlagsFound > 0) {
            upsellString = format(
                loc(editorUpsellLabelWithSuggestionsExpired),
                proofingViewState.premimumFlagsFound.toString()
            );
        }
    }

    buttonString =
        premiumPreviewStatus === PremiumPreviewStatus.New
            ? loc(skittleDialogSettingsTryItNowButton)
            : loc(skittleGoPremiumButton);
    // for all other scenarios, we should use deafult string
    upsellString = upsellString || loc(settingsDialogTrySuggestionsString);

    return { upsellString, buttonString };
}
